import React, {
  useEffect, useRef, useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import { ASSETS_BASE_URL } from '../../../constants/endpoints';
import { ICategory } from '../../../types';
import { ReactComponent as Checkmark } from '../../../assets/icons/svg/shared/ic-shared-checkmark.svg';
import Button from '../../../generic-components/Button';
import {
  STYLES,
  CATEGORIZATION_TYPES,
  ACTION_TYPES,
  BUSINESS_PERCENT,
} from '../constants';
import { CategorizationPanel } from './CategorizationPanel';

interface IProps {
  categoryList: ICategory[];
  handlePickCategoryId: (id: string | null, businessPercent?: number) => void;
  activeCategoryId?: string;
  className?: string;
  showAnimation?: boolean;
  headerRightAddon?: React.ReactNode,
  headerLeftAddon: React.ReactNode,
  categorizationType?: string;
  showCategorizationPanel?: boolean;
}

export const CategorizeTaxIdPicker = ({
  categoryList,
  handlePickCategoryId,
  activeCategoryId,
  className,
  showAnimation = true,
  headerLeftAddon,
  headerRightAddon,
  categorizationType,
  showCategorizationPanel,
} :IProps) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<string>('');
  const elWrapper = useRef<HTMLDivElement | null>(null);
  const { t } = useTranslation();
  const handlePickCategory = (id: string) => {
    setSelectedCategoryId(id);
  };

  const handleSubmit = () => {
    if (showAnimation) {
      if (elWrapper.current) {
        elWrapper.current?.classList.remove('animate-ItemfadeIn');
        setTimeout(() => {
          elWrapper.current?.classList.add('animate-ItemfadeInReverse');
        }, 100);
      }
    }
    setTimeout(() => {
      handlePickCategoryId(selectedCategoryId);
    }, showAnimation ? 700 : 0);
  };

  useEffect(() => {
    if (!activeCategoryId) {
      setSelectedCategoryId(categoryList?.[0]?.id || '');
    } else {
      setSelectedCategoryId(activeCategoryId);
    }
  }, []);
  const getHeadingTitle = () => {
    const defaultTitle = t('CATEGORIZE_EXPENSES_COMPONENT_CATEGORY_LABEL');
    if (!categorizationType) return defaultTitle;
    if (categorizationType === CATEGORIZATION_TYPES.EXPENSE) return t('CATEGORIZE_EXPENSES_COMPONENT_HEADING_EXPENSES_LABEL');
    if (categorizationType === CATEGORIZATION_TYPES.INCOME) return t('CATEGORIZE_EXPENSES_COMPONENT_HEADING_INCOME_LABEL');
    return defaultTitle;
  };

  const handleCategorizationActionClick = (actionType: string) => handlePickCategoryId(selectedCategoryId, actionType === ACTION_TYPES.WORK ? BUSINESS_PERCENT.WORK : BUSINESS_PERCENT.LIFE);

  return (
    <div ref={elWrapper} onClick={() => {}} onKeyDown={() => {}} role='button' tabIndex={0} className={`${STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_WRAPPER} ${showAnimation && 'animate-ItemfadeIn'} ${className ?? ''}`}>
      <div className='px-[14px] flex items-center w-full text-center pb-[24px] pt-[30px] border-b border-bw03 justify-between'>
        <div className='flex items-center'>
          {headerLeftAddon}
          <Heading title={getHeadingTitle()} className={STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_TITLE} />
        </div>
        {headerRightAddon}
      </div>
      <div className={STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_SCROLL_CONTAINER}>
        {categoryList && categoryList.map((category: ICategory) => (
          <div
            id={category.title?.replace(/[^a-z0-9s+]/gi, '')}
            onClick={(event) => { event.stopPropagation(); handlePickCategory(category.id); }}
            onKeyDown={() => {}}
            role='button'
            tabIndex={0}
            className={`${STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_ITEM} ${category.id === selectedCategoryId ? STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_ITEM_SELECTED : 'text-bw06'}`}
            key={category.id}
          >
            <div className={STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_ICON_WRAPPER}>
              <img className={`${STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_ICON} ${selectedCategoryId === category.id ? 'hidden' : ''}`} alt='Icon' src={`${ASSETS_BASE_URL}/webapp/categories/${category?.imageName.replace(' ', '')}.svg`} />
              {/* //TODO: Change category icon color in CDN */}
              <img className={`${STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_ICON} ${selectedCategoryId === category.id ? 'inline top-[-2px]' : 'hidden'}`} alt='Icon' src={`${ASSETS_BASE_URL}/webapp/tinted_categoriesv2/${category?.imageName.replace(' ', '')}.svg`} />
            </div>
            {category.title}
            {category.id === selectedCategoryId && <Checkmark className='w-[18px] ml-auto text-action03' />}
          </div>
        ))}
      </div>

      <div className={STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_FOOTER}>
        {showCategorizationPanel && <CategorizationPanel handleActionClick={handleCategorizationActionClick} />}
        {
          !showCategorizationPanel
          && (
            <Button
              className={STYLES.MAIN_SECTION.CATEGORY_TAX_ID_PICKER_FOOTER_CTA}
              title={t('CATEGORIZE_EXPENSES_COMPONENT_FOOTER_CTA')}
              id='setBusinessCategoryCta'
              onClick={handleSubmit}
            />
          )
        }
      </div>
    </div>
  );
};
